import React, { useEffect, useState } from 'react'
import { Box, display } from '@mui/system'
import { Paper, Table, TableBody, TableCell, TableHead, TableRow, Divider, TablePagination, Button, Switch, Grid, Typography, MenuItem, Select, TextField, TableContainer, IconButton } from '@mui/material';
import { useDispatch } from 'react-redux'
import SearchIcon from '@mui/icons-material/Search';
import CandidateSideBar from './Profile/CandidateSideBar'
import Navbar from '../Navbar'
import companyLogo from '../../images/companyLogo.jpg'
import BookmarkBorderIcon from '@mui/icons-material/BookmarkBorder';
import AppliedJobsTable from './AppliedJobsTable';
import Layout from '../../assets/Layout';
import UserLayout from '../../assets/UserLayout';
import { useNavigate } from 'react-router-dom';
import LocationOnOutlinedIcon from '@mui/icons-material/LocationOnOutlined';
import VideocamIcon from '@mui/icons-material/Videocam';
import RemoveRedEyeOutlinedIcon from '@mui/icons-material/RemoveRedEyeOutlined';

export default function CandidateUpcomingService() {
    const [user, setUser] = useState("");
    const dispatch = useDispatch();
    const [isDrawerOpen, setIsDrawerOpen] = useState(true);

    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] = useState(5);
    const [checked, setChecked] = useState(false);
    const [date, setDate] = useState("");
    const [selectedOption, setSelectedOption] = useState('');
    const [fromDate, setFromDate] = useState('');
    const [toDate, setToDate] = useState('');
    const handleFromDateChange = (event) => {
        setFromDate(event.target.value);
    };

    const handleToDateChange = (event) => {
        setToDate(event.target.value);
    };

    const handleChange1 = (event) => {
        setSelectedOption(event.target.value);
    };

    const handleChange = () => {
        setChecked(!checked);
    };

    const navigate = useNavigate();


    const data = [
        { id: 1, header1: 'Ackrolix Innovation', header2: 'Data 2', header3: 'Data 3', header4: '24- April 2023', header5: 'Data 5', header6: 'Deactivate', header7: 'Data 7' },
        { id: 2, header1: 'Data 1', header2: 'UI UX Designer', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Activate', header7: 'Data 7' },
        { id: 3, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Rejected', header7: 'Data 7' },
        { id: 4, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Under Review', header7: 'Data 7' },
        { id: 5, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Draft', header7: 'Data 7' },
        { id: 6, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Data 6', header7: 'Data 7' },
        { id: 7, header1: 'Data 1', header2: 'Data 2', header3: 'Data 3', header4: 'Data 4', header5: 'Data 5', header6: 'Data 6', header7: 'Data 7' },
        // Add more data objects as needed
    ];

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };

    const emptyRows = rowsPerPage - Math.min(rowsPerPage, data.length - page * rowsPerPage);

    // const handleDrawerToggle = () => {
    //     setIsDrawerOpen(!isDrawerOpen);
    // };

    // useEffect(() => {
    //     if (localStorage.getItem("refreshToken")) {
    //         dispatch(getUserInformation({}, (data) => {
    //             dispatch({
    //                 type: "LOG_IN",
    //                 payload: data.data.data,
    //             });
    //             localStorage.setItem("user", JSON.stringify(data.data.data));
    //             setUser(data.data.data);
    //         }, (err) => {
    //             console.log(err);
    //         }, localStorage.getItem("refreshToken")
    //         ))
    //     }
    // }, []);

    const handleSearch = (event) => {
        const searchTerm = event.target.value;
    };

    return (
        <>
            <Layout>
                <UserLayout>
                    <Box sx={{ display: 'flex', flexDirection: 'row', mt: 8, borderRadius: '10px' }}>
                        <Typography variant="h6" sx={{ fontWeight: 'bold', width: '100%' }}>Upcoming Service</Typography>
                        <Grid item md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', }}>
                            <TextField
                                sx={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                                className='profile-skills-box text2Light'
                                variant="outlined"
                                size="small"
                                placeholder="Search"
                                onChange={handleSearch}
                                InputProps={{
                                    endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                                }}
                            />
                        </Grid>
                    </Box>
                    <Grid item md={12} mt={2}>
                        <Paper sx={{ px: 5, py: 2, boxShadow: 'none', border: '1px solid #e0e0e0' }} >
                            <Grid container my={2} >
                                <Grid item md={4} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                                    <Typography className='text2Bold'>Show</Typography>
                                    <select
                                        style={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                                        className='profile-skills-box text2Light'

                                        value={selectedOption}
                                        onChange={handleChange}
                                    >
                                        <option value="">None</option>
                                        <option value="option1">Option 1</option>
                                        <option value="option2">Option 2</option>
                                        <option value="option3">Option 3</option>
                                    </select>
                                    <Typography className='text2Bold' ml={1}>Enteries</Typography>
                                </Grid>
                                <Grid item md={6}></Grid>

                                <Grid item md={2} sx={{ display: 'flex', verticalAlign: 'middle', alignItems: 'center', height: '2.5rem' }}>
                                    <TextField
                                        sx={{ marginLeft: '1rem', backgroundColor: '#D9E3F6' }}
                                        className='profile-skills-box text2Light'
                                        variant="outlined"
                                        size="small"
                                        placeholder="Search"
                                        onChange={handleSearch}
                                        InputProps={{
                                            endAdornment: <SearchIcon sx={{ opacity: '0.5' }} />,
                                        }}
                                    />
                                </Grid>
                            </Grid >

                            <Paper sx={{ boxShadow: 'none', border: '1px solid #e0e0e0' }}>
                                <Grid container>
                                    <Grid item xs={12}>
                                        <TableContainer sx={{ width: '100%', overflowX: 'auto' }}>
                                            <Table width="auto">
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                            Coach
                                                        </TableCell>
                                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                            Service
                                                        </TableCell>
                                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                            Date & Time
                                                        </TableCell>
                                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                            Duration
                                                        </TableCell>
                                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                            Session
                                                        </TableCell>
                                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                            Join
                                                        </TableCell>
                                                        <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                            Status
                                                        </TableCell>
                                                      
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {(rowsPerPage > 0
                                                        ? data.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                        : data
                                                    ).map((row) => (
                                                        <TableRow key={row.id}>
                                                            <TableCell className='text2Mid' style={{ width: 'fit-content', textAlign: 'center', color: '#2544EE' }}>
                                                                Anuj Sharma
                                                            </TableCell>
                                                            <TableCell className='text2Mid' style={{ width: 'fit-content', textAlign: 'center', color: '#2544EE'  }}>UI-UX Design </TableCell>
                                                            <TableCell className='text2Mid' style={{ width: 'fit-content', textAlign: 'center', }}>10 May 2023 2:00 PM </TableCell>
                                                            <TableCell className='text2Mid' style={{ width: 'fit-content', textAlign: 'center' }}>
                                                                    60 min
                                                            </TableCell>
                                                            <TableCell className='text2Mid' style={{ width: 'fit-content', textAlign: 'center', fontWeight: 'bold' }}>3 Session</TableCell>
                                                            <TableCell className='text2Mid' style={{ width: 'fit-content', textAlign: 'center', fontWeight: 'bold' }}>
                                                                <IconButton
                                                                    sx={{
                                                                        color: '#2544EE',
                                                                    }}
                                                                >
                                                                    <VideocamIcon />
                                                                </IconButton>
                                                            </TableCell>
                                                            <TableCell className='text2Bold' style={{ width: 'fit-content', textAlign: 'center', fontWeight: 'bold', color:'#17BB05' }}>Completed</TableCell>
                                                       

                                                        </TableRow>
                                                    ))}

                                                    {emptyRows > 0 && (
                                                        <TableRow style={{ height: 53 * emptyRows }}>
                                                            <TableCell colSpan={8} />
                                                        </TableRow>
                                                    )}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                                <TablePagination
                                    rowsPerPageOptions={[5, 10, 25, { label: 'All', value: -1 }]}
                                    component="div"
                                    count={data.length}
                                    rowsPerPage={rowsPerPage}
                                    page={page}
                                    onPageChange={handleChangePage}
                                    onRowsPerPageChange={handleChangeRowsPerPage}
                                />
                            </Paper>
                        </Paper>
                    </Grid>
                </UserLayout>
            </Layout>
        </>
    )
}
